<template>
    <!--TODO Mejorar la presentación-->
    <div class="home">
        <img alt="Vue logo" src="../assets/logo.png" class="mt-5">

        <div class="mt-4">
            <h3 class="mb-4">Página no encontrada</h3>
            <b-button @click="$router.go(-1)"><font-awesome-icon icon="angle-left"></font-awesome-icon> Regresar</b-button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
    name: 'Home',
    components: {
    // HelloWorld
    }
}
</script>
